import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { Role } from '../../models/role';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: []
})
export class RoleComponent implements OnInit {

  title_component: string;
  title_panel: string;
  roles: Role[];
  role_id: number;

  constructor(
    private router: Router,
    private roleService: RoleService,
    private baseService: BaseService
  ) { }

  ngOnInit(): any {
    this.title_component = 'Roles';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Lista de Roles';

    this.roleService.getAll()
    .subscribe(data => {
        if (data) {
          this.roles = data;
        }
    });
  }

  getRoleDetail(event, role: Role): any {
    this.role_id = role.id;
    const link = ['/dashboard/role', this.role_id];
    this.router.navigate(link);
  }

  getPermissionDetail(event, role: Role): any {
    this.role_id = role.id;
    const link = ['/dashboard/permission', this.role_id];
    this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/role/role.component.ts